import React, { useContext } from "react";
import FormatDate from "src/utils/FormatDate";
import Label from "src/components/Label";
import FluidImage from "src/utils/FluidImage";
import Heading from "src/components/Heading";
import Wave from "src/utils/Wave";
import { PageContext } from "src/utils/context";
import CustomBreadcrumbs from 'src/utils/CustomBreadcrumbs'

const ContentHeadingCentered = (props) => {
  const context = useContext(PageContext)
  props = props.notBlock ? props : context

  return (
    <div className="relative">
      <div className={`bg-lightblue px-6 pt-32 pb-40 xl:pt-36 2xl:pt-40`}>
        {props.notBlock || true ? //Hard Coded the condition for Not using
          <Label className="text-tealblue text-center" p={true}>
            {props.first_published_at ? FormatDate(props.first_published_at) : ""}&nbsp;&nbsp;·&nbsp;&nbsp;
            {props.content.component.replace(/-/g, " ").replace(/_/g, " ")}
          </Label>
          : <CustomBreadcrumbs className="mb-6 mx-auto text-center"/>
        }
        <Heading
          size="h1"
          className="text-darkblue mx-auto mt-6 max-w-6xl text-center lg:mt-8 text-2xl md:text-3xl lg:text-4xl font-medium"
        >
          {props.name}
        </Heading>
        <p className="text-darkblue-400 mx-auto mt-6 max-w-3xl text-center text-sm tracking-[-0.02em] lg:mt-8 lg:text-base">
          {props.content.description}
        </p>
      </div>
      <Wave size="small" className="fill-lightblue" />
      <div className="rounded-md px-6">
        <FluidImage
          className="mx-auto -mt-32 max-w-[813px] rounded-md md:-mt-36 lg:-mt-36 xl:-mt-40 2xl:-mt-52"
          image={props.content.featured_image}
        />
      </div>
    </div>
  );
};

export default ContentHeadingCentered;
